import React from 'react';
import './VideoPreview.css';

interface VideoPreviewProps {
  thumbnails: string[];
  onSelect: (index: number) => void;
  selectedVideoIndex: number;
}

const VideoPreview: React.FC<VideoPreviewProps> = ({ thumbnails, onSelect, selectedVideoIndex }) => {
  return (
    <div className="videocreativo-thumbnails-container">
      {thumbnails.map((thumbnail, index) => (
        <div
          key={index}
          className={`videocreativo-thumbnail-wrapper ${
            selectedVideoIndex === index ? 'videocreativo-thumbnail-selected' : ''
          }`}
          onClick={() => onSelect(index)}
        >
          <img
            src={thumbnail}
            alt={`Thumbnail ${index}`}
            className="videocreativo-thumbnail"
          />
        </div>
      ))}
    </div>
  );
};

export default VideoPreview;
